/**
 * GuestShell — Minimal shell for restricted guest access.
 * No nav rail, no sidebar, no session history. Chat-only.
 */

import { type ReactNode } from "react";
import { useNavigate } from "@tanstack/react-router";
import { LogOut } from "lucide-react";
import { ScanlineOverlay } from "../components/ui/ScanlineOverlay";

interface GuestShellProps {
  children: ReactNode;
}

export function GuestShell({ children }: GuestShellProps) {
  const navigate = useNavigate();

  async function handleLogout() {
    await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
    navigate({ to: "/login" });
  }

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-[var(--bw-bg)] text-[var(--bw-fg)]">
      <ScanlineOverlay />

      {/* Top bar */}
      <header className="flex-shrink-0 flex items-center justify-between px-4 py-2 border-b border-[var(--bw-border)] bg-[var(--bw-surface)]">
        <span
          className="text-[10px] uppercase tracking-[0.25em] font-mono"
          style={{ color: "var(--bw-accent)" }}
        >
          // CONSOLE
        </span>

        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 px-2.5 py-1 text-xs font-mono border border-[var(--bw-border)] text-[var(--bw-muted)] hover:text-[var(--bw-danger)] hover:border-[var(--bw-danger)] transition-colors"
          title="Cerrar sesión"
        >
          <LogOut size={12} />
          <span>SALIR</span>
        </button>
      </header>

      {/* Content */}
      <main className="flex-1 overflow-hidden">
        {children}
      </main>
    </div>
  );
}
